<template>
   <footer class="footer p-b-20 coral-Body--S">
      Made with ❤️ by <a href="https://bit.ly/elias-webbites" rel="noopener" target="_blank" class="coral-Link">Elias</a>
      <dir class="d-inline-block m-0 p-l-15 p-r-10">
        <hr class="coral-Divider--M coral-Divider--vertical m-0" style="height:14px;">
      </dir>
      <a
        rel="noopener"
        target="_blank"
        href="https://www.paypal.com/donate/?hosted_button_id=5PMNX4DPW83KN"
        class="coral-Link"
      >
          Support the project
      </a>
    </footer>
</template>

<script>

export default {
    name:"Footer",

    directives:{},

    components:{},
    
    data(){
        return{
        }
    },

    props:{},

    methods:{}
}
</script>

<style>

</style>